<template>
  <v-dialog v-model="dialog" width="900">
    <v-card min-height="85vh">
      <v-toolbar flat dark color="primary">
        <v-btn icon dark @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title> Relatórios </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-progress-circular v-if="abrindoRelatorio" :size="20" width="2" indeterminate />
      </v-toolbar>

      <v-container fluid>
        <v-card>
          <v-card-title> Filtros do relatório </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="3">
                <v-radio-group v-model="exibirEntradaSaida" class="pt-0 mt-0">
                  <template #label>
                    <div><strong>Exibir</strong></div>
                  </template>
                  <v-radio label="Entrada" value="entrada" />
                  <v-radio label="Saída" value="saida" />
                  <v-radio label="Ambos" value="ambos" />
                </v-radio-group>
              </v-col>

              <v-col cols="3">
                <v-radio-group v-model="filtrarStatus" class="pt-0 mt-0">
                  <template #label>
                    <div><strong>Filtrar</strong></div>
                  </template>
                  <v-radio label="Conferidos" value="CONFERIDO" />
                  <v-radio label="Em dúvida" value="EM_DUVIDA" />
                  <v-radio label="Não Conferidos" value="NAO_CONFERIDO" />
                  <v-radio label="Todos" value="TODOS" />
                </v-radio-group>
              </v-col>

              <v-col cols="3">
                <v-radio-group v-model="filtrarAzulVermelho" class="pt-0 mt-0">
                  <template #label>
                    <div><strong>Filtrar</strong></div>
                  </template>
                  <v-radio label="Azul" value="azul" />
                  <v-radio label="Vermelho" value="vermelho" />
                  <v-radio label="Ambos" value="ambos" />
                </v-radio-group>
              </v-col>

              <v-col cols="3">
                <v-checkbox v-model="mostrarCest" label="Mostrar CEST" />
              </v-col>

              <v-col cols="12">
                <v-autocomplete
                  v-model="ordenacaoRelatorio"
                  :items="itensOrdenacao"
                  label="Ordenação"
                />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-container>

      <v-data-table
        class="mt-3"
        :headers="headers"
        :items="relatorios"
        hide-default-footer
        hide-default-header
      >
        <template #[`item.pdf`]="{ item }">
          <v-tooltip top>
            <template #activator="{ on }">
              <v-icon
                v-if="item.tipo !== 'RESUMO'"
                medium
                class="mr-1"
                v-on="on"
                @click="abrirPDF(item)"
              >
                mdi-file-pdf-box
              </v-icon>
            </template>
            <span> Abrir Relatório </span>
          </v-tooltip>

          <v-tooltip top>
            <template #activator="{ on }">
              <v-icon
                v-if="item.tipo === 'DIVERGENCIAS_ICMS' || item.tipo === 'DIVERGENCIAS_PIS_COFINS'"
                @click="baixarExcel(item)"
                v-on="on"
              >
                mdi-file-excel-box
              </v-icon>
            </template>
            <span> Baixar Excel </span>
          </v-tooltip>
          <v-tooltip top>
            <template #activator="{ on }">
              <v-icon
                v-if="item.tipo === 'RESUMO'"
                medium
                class="mr-1"
                v-on="on"
                @click="showDialogResumoBasico = true"
              >
                mdi-eye-outline
              </v-icon>
            </template>
            <span> Visualizar Resumo </span>
          </v-tooltip>
        </template>
      </v-data-table>
    </v-card>

    <DialogDeResumoBasico
      :show-dialog-resumo-basico.sync="showDialogResumoBasico"
      :atualizacao-param="atualizacao"
    />

    <SnackbarMessage
      :show-snack.sync="snackbar.showSnackParam"
      :snack-text="snackbar.snackTextParam"
      :snack-type="snackbar.snackTypeParam"
    />
  </v-dialog>
</template>

<script>
import SnackbarMessage from '@/components/SnackbarMessage'
import SnackBar from '@/models/components/snackbar'
import AppAxios from '@/common/request'
import DialogDeResumoBasico from './DialogDeResumoBasico.vue'

export default {
  name: 'DialogDeListagemDeRelatorios',

  components: { SnackbarMessage, DialogDeResumoBasico },

  props: ['showDialog', 'atualizacao'],

  data: () => ({
    dialog: false,
    headers: [
      { text: '', value: 'nome' },
      { text: '', value: 'pdf' }
    ],
    relatorios: [
      { nome: 'Divergências PIS/COFINS', tipo: 'DIVERGENCIAS_PIS_COFINS' },
      { nome: 'Divergências ICMS', tipo: 'DIVERGENCIAS_ICMS' },
      { nome: 'Extrato', tipo: 'EXTRATO_AUDITORIA' },
      { nome: 'Itens com NCM Divergentes', tipo: 'NCMS_DIVERGENTES' },
      { nome: 'Itens com NCM não Vigentes', tipo: 'NCMS_NAO_VIGENTES' },
      { nome: 'Resumo Básico', tipo: 'RESUMO' }
    ],
    itensOrdenacao: [
      { text: 'Código do item', value: 'CODIGO_ITEM' },
      { text: 'Descrição do item', value: 'DESCRICAO_ITEM' },
      { text: 'Maior venda', value: 'MAIOR_VENDA' },
      { text: 'Maior compra', value: 'MAIOR_COMPRA' },
      {
        text: 'Valor da Divergência de Imposto na Saída',
        value: 'VALOR_DIVERG_IMPOSTO_SAIDA'
      },
      { text: 'Valor da Divergência de Imposto na Entrada', value: 'VALOR_DIVERG_IMPOSTO_ENTRADA' }
    ],
    ordenacaoRelatorio: 'CODIGO_ITEM',
    exibirEntradaSaida: 'ambos',
    filtrarStatus: 'TODOS',
    filtrarAzulVermelho: 'ambos',
    mostrarCest: true,
    snackbar: new SnackBar(),
    abrindoRelatorio: false,
    showDialogResumoBasico: false
  }),

  watch: {
    showDialog() {
      return this.showDialog ? (this.dialog = this.showDialog) : ''
    },

    dialog() {
      return this.dialog ? true : this.fecharDialog()
    }
  },

  methods: {
    fecharDialog() {
      this.$emit('update:showDialog', false)
    },

    async abrirPDF(item) {
      this.abrindoRelatorio = true

      const params = {
        ordenacao: this.ordenacaoRelatorio,
        exibeEntrada: this.exibirEntradaSaida === 'entrada' || this.exibirEntradaSaida === 'ambos',
        exibeSaida: this.exibirEntradaSaida === 'saida' || this.exibirEntradaSaida === 'ambos',
        statusConferencia: this.filtrarStatus,
        filtraAzul: this.filtrarAzulVermelho === 'azul' || this.filtrarAzulVermelho === 'ambos',
        filtraVermelho:
          this.filtrarAzulVermelho === 'vermelho' || this.filtrarAzulVermelho === 'ambos',
        mostrarCest: this.mostrarCest
      }

      await AppAxios.get('/relatorios/' + this.atualizacao.id + '/' + item.tipo, {
        responseType: 'arraybuffer',
        params
      })
        .then((response) => {
          const blob = new Blob([response], { type: 'application/pdf' })
          var link = URL.createObjectURL(blob)
          window.open(link, '_blank')
        })
        .catch((error) => {
          this.snackbar.snackTextParam = 'Não foi possível abrir o PDF. Error: ' + error
          this.snackbar.snackTypeParam = 'error'
          this.snackbar.showSnackParam = true
        })
        .finally(() => (this.abrindoRelatorio = false))
    },

    async baixarExcel(item) {
      this.abrindoRelatorio = true

      const params = {
        ordenacao: this.ordenacaoRelatorio,
        exibeEntrada: this.exibirEntradaSaida === 'entrada' || this.exibirEntradaSaida === 'ambos',
        exibeSaida: this.exibirEntradaSaida === 'saida' || this.exibirEntradaSaida === 'ambos',
        statusConferencia: this.filtrarStatus,
        filtraAzul: this.filtrarAzulVermelho === 'azul' || this.filtrarAzulVermelho === 'ambos',
        filtraVermelho:
          this.filtrarAzulVermelho === 'vermelho' || this.filtrarAzulVermelho === 'ambos',
        mostrarCest: this.mostrarCest
      }

      await AppAxios.get('/relatorios/excel/' + this.atualizacao.id + '/' + item.tipo, {
        responseType: 'blob',
        params
      })
        .then((response) => {
          const url = URL.createObjectURL(
            new Blob([response], {
              type: 'application/vnd.ms-excel'
            })
          )
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', item.tipo)
          document.body.appendChild(link)
          link.click()
        })
        .catch((error) => {
          this.snackbar.snackTextParam = 'Não foi possível abrir o EXCEL. Error: ' + error
          this.snackbar.snackTypeParam = 'error'
          this.snackbar.showSnackParam = true
        })
        .finally(() => (this.abrindoRelatorio = false))
    }
  }
}
</script>
